"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var core_1 = __importStar(require("@gin-betting/core"));
var utils_1 = require("./utils");
var constants_1 = require("./constants");
var handleCreateBetsRequest_1 = __importDefault(require("./reducer-handlers/handleCreateBetsRequest"));
var handleCreateBetsSuccess_1 = __importDefault(require("./reducer-handlers/handleCreateBetsSuccess"));
var handleCreateBetsFail_1 = __importDefault(require("./reducer-handlers/handleCreateBetsFail"));
var handleUpdateBet_1 = __importDefault(require("./reducer-handlers/handleUpdateBet"));
var handleDeleteBetslipBet_1 = __importDefault(require("./reducer-handlers/handleDeleteBetslipBet"));
var handleSetInitialBetslip_1 = __importDefault(require("./reducer-handlers/handleSetInitialBetslip"));
var handleAdoptUnaffectedBetslipOdds_1 = __importDefault(require("./reducer-handlers/handleAdoptUnaffectedBetslipOdds"));
var handleAddBetslipBet_1 = __importDefault(require("./reducer-handlers/handleAddBetslipBet"));
var handleUpdateBetslipOddsByBet_1 = __importDefault(require("./reducer-handlers/handleUpdateBetslipOddsByBet"));
var UPDATE_BET = core_1.default.async.constants.UPDATE_BET, getIdsFromBetslipOddId = core_1.default.utils.getIdsFromBetslipOddId;
var BetslipStateRecord = immutable_1.Record({
    betslipOdds: immutable_1.OrderedMap(),
    betslipBets: immutable_1.OrderedMap(),
    oddUpdateStatus: core_1.App.OddUpdateStatus.acceptHigher,
    chosenBetslipBetId: null,
}, 'BetslipState');
var defaultBetslipBet = utils_1.createBetslipBet();
var initialState = new BetslipStateRecord({
    betslipBets: immutable_1.OrderedMap((_a = {},
        _a[defaultBetslipBet.id] = defaultBetslipBet,
        _a)),
});
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case constants_1.CHOSE_BETSLIP_BET_ID: {
            var betslipBetId = action.payload.betslipBetId;
            var chosenBetslipBetId = state.chosenBetslipBetId;
            var nextChosenBetslipBetId = betslipBetId === chosenBetslipBetId ? null : betslipBetId;
            return state.set('chosenBetslipBetId', nextChosenBetslipBetId);
        }
        case constants_1.CHANGE_BET_MODE: {
            var _a = action.payload, mode = _a.mode, betslipBetId = _a.betslipBetId;
            var betslipBets = state.betslipBets;
            var betslipBet = betslipBets.get(betslipBetId);
            if (!betslipBet)
                return state;
            var nextBetslipBet = __assign(__assign({}, betslipBet), { mode: mode });
            var nextBetslipBets = betslipBets.set(nextBetslipBet.id, nextBetslipBet);
            return state.set('betslipBets', nextBetslipBets);
        }
        case constants_1.DELETE_BETSLIP_ODDS: {
            var betslipBetId = action.payload.betslipBetId;
            var betslipBets = state.betslipBets, betslipOdds = state.betslipOdds;
            var betslipBet = betslipBets.get(betslipBetId);
            if (!betslipBet)
                return state;
            var betslipOddIds = betslipBet.betslipOddIds;
            var nextBetslipOddIds = betslipOddIds.clear();
            var nextBetslipBet = __assign(__assign({}, betslipBet), { betslipOddIds: nextBetslipOddIds });
            var nextBetslipOdds = betslipOdds.deleteAll(betslipOddIds);
            var nextBetslipBets = betslipBets.set(nextBetslipBet.id, nextBetslipBet);
            return state
                .set('betslipBets', nextBetslipBets)
                .set('betslipOdds', nextBetslipOdds);
        }
        case constants_1.CHANGE_COEF_UPDATES: {
            var oddUpdateStatus = action.payload.oddUpdateStatus;
            return state.set('oddUpdateStatus', oddUpdateStatus);
        }
        case constants_1.TOGGLE_SYSTEM_COMBINATION: {
            var _b = action.payload, betslipBetId = _b.betslipBetId, combinationNumber = _b.combinationNumber;
            var betslipBets = state.betslipBets;
            var betslipBet = betslipBets.get(betslipBetId);
            if (!betslipBet)
                return state;
            var systemSize = betslipBet.systemSize;
            var nextSystemSize = systemSize.includes(combinationNumber)
                ? []
                : [combinationNumber];
            var nextBetslipBet = __assign(__assign({}, betslipBet), { systemSize: nextSystemSize });
            var nextBetslipBets = betslipBets.set(nextBetslipBet.id, nextBetslipBet);
            return state.set('betslipBets', nextBetslipBets);
        }
        case constants_1.ADD_BETSLIP_ODD: {
            var _c = action.payload, betslipBetId = _c.betslipBetId, oddId = _c.oddId;
            var betslipBets = state.betslipBets, betslipOdds = state.betslipOdds;
            var betslipBet = betslipBets.get(betslipBetId);
            if (!betslipBet)
                return state;
            var newBetslipOddId = utils_1.getBetslipOddId({
                oddId: oddId,
                betslipBetId: betslipBet.id,
            });
            var newBetslipOdd = utils_1.createBetslipOdd(newBetslipOddId);
            var betslipOddIds = betslipBet.betslipOddIds;
            var nextBetslipOddIds = betslipOddIds.add(newBetslipOddId);
            var nextBetslipBet = __assign(__assign({}, betslipBet), { betslipOddIds: nextBetslipOddIds });
            var nextBetslipBets = betslipBets.set(nextBetslipBet.id, nextBetslipBet);
            var nextBetslipOdds = betslipOdds.set(newBetslipOdd.id, newBetslipOdd);
            return state
                .set('betslipBets', nextBetslipBets)
                .set('betslipOdds', nextBetslipOdds);
        }
        case constants_1.DELETE_BETSLIP_ODD: {
            var _d = action.payload, oddId = _d.oddId, betslipBetId = _d.betslipBetId;
            var betslipBets = state.betslipBets, betslipOdds = state.betslipOdds;
            var betslipOddId = utils_1.getBetslipOddId({ oddId: oddId, betslipBetId: betslipBetId });
            var betslipBet = betslipBets.get(betslipBetId);
            if (!betslipBet)
                return state;
            var betslipOddIds = betslipBet.betslipOddIds;
            var nextBetslipOddIds = betslipOddIds.delete(betslipOddId);
            var nextBetslipBet = __assign(__assign({}, betslipBet), { betslipOddIds: nextBetslipOddIds });
            var nextBetslipBets = betslipBets.set(nextBetslipBet.id, nextBetslipBet);
            var nextBetslipOdds = betslipOdds.delete(betslipOddId);
            return state
                .set('betslipBets', nextBetslipBets)
                .set('betslipOdds', nextBetslipOdds);
        }
        case constants_1.CHANGE_BETSLIP_ODD_STAKE: {
            var _e = action.payload, betslipOddId = _e.betslipOddId, stake = _e.stake;
            var betslipOdds = state.betslipOdds;
            var betslipOdd = betslipOdds.get(betslipOddId);
            if (!betslipOdd)
                return state;
            var nextBetslipOdd = __assign(__assign({}, betslipOdd), { singleStake: stake });
            var nextBetslipOdds = betslipOdds.set(nextBetslipOdd.id, nextBetslipOdd);
            return state.set('betslipOdds', nextBetslipOdds);
        }
        case constants_1.CHANGE_BETSLIP_BET_STAKE: {
            var _f = action.payload, betslipBetId = _f.betslipBetId, stake = _f.stake;
            var betslipBets = state.betslipBets;
            var betslipBet = betslipBets.get(betslipBetId);
            if (!betslipBet)
                return state;
            var nextBetslipBet = __assign(__assign({}, betslipBet), { stake: stake });
            var nextBetslipBets = betslipBets.set(nextBetslipBet.id, nextBetslipBet);
            return state.set('betslipBets', nextBetslipBets);
        }
        case constants_1.GET_MISSING_MATCHES_SUCCESS: {
            var _g = action.payload, entities = _g.entities, missingMatchIds_1 = _g.missingMatchIds;
            var odds_1 = entities.odds;
            var betslipBets = state.betslipBets, betslipOdds_1 = state.betslipOdds;
            var nextBetslipOdds_1 = betslipOdds_1;
            var nextBetslipBets_1 = betslipBets.map(function (betslipBet) {
                var betslipOddIds = betslipBet.betslipOddIds;
                var nextBetslipOddIds = betslipOddIds.filter(function (betslipOddId) {
                    var betslipOdd = betslipOdds_1.get(betslipOddId);
                    if (!betslipOdd)
                        return false;
                    var _a = getIdsFromBetslipOddId(betslipOddId), oddId = _a.oddId, matchId = _a.matchId;
                    if (missingMatchIds_1.includes(matchId) &&
                        (!odds_1 || !odds_1[oddId])) {
                        nextBetslipOdds_1 = nextBetslipOdds_1.delete(betslipOddId);
                        return false;
                    }
                    return true;
                });
                return __assign(__assign({}, betslipBet), { betslipOddIds: nextBetslipOddIds });
            });
            // --start addition check
            nextBetslipOdds_1 = nextBetslipOdds_1.filter(function (betslipOdd) {
                var betslipOddId = betslipOdd.id;
                var betslipBetId = getIdsFromBetslipOddId(betslipOddId).betslipBetId;
                if (!nextBetslipBets_1.has(betslipBetId)) {
                    return false;
                }
                return true;
            });
            // --end addition check
            return state
                .set('betslipOdds', nextBetslipOdds_1)
                .set('betslipBets', nextBetslipBets_1);
        }
        case constants_1.CREATE_BETS_REQUEST: {
            return handleCreateBetsRequest_1.default(state, action);
        }
        case constants_1.CREATE_BETS_SUCCESS: {
            return handleCreateBetsSuccess_1.default(state, action);
        }
        case constants_1.CREATE_BETS_FAIL: {
            return handleCreateBetsFail_1.default(state, action);
        }
        case constants_1.UPDATE_BETSLIP_ODDS_BY_BET: {
            return handleUpdateBetslipOddsByBet_1.default(state, action);
        }
        case UPDATE_BET: {
            return handleUpdateBet_1.default(state, action);
        }
        case constants_1.DELETE_BETSLIP_BET: {
            return handleDeleteBetslipBet_1.default(state, action);
        }
        case constants_1.SET_INITIAL_BETSLIP: {
            return handleSetInitialBetslip_1.default(state, action);
        }
        case constants_1.ADOPT_UNAFFECTED_BETSLIP_ODDS: {
            return handleAdoptUnaffectedBetslipOdds_1.default(state, action);
        }
        case constants_1.ADD_BETSLIP_BET: {
            return handleAddBetslipBet_1.default(state);
        }
        default:
            return state;
    }
}
exports.default = reducer;
//# sourceMappingURL=reducer.js.map